(() => {
  'use strict';
  const KEY = 'cantemiri_wishlist_v1';
  const MAX = 100;
  const root = window.Shopify?.routes?.root || '/';
  const pageUrl = root + 'pages/wishlist';
  const products = new Map();
  let saved = [];
  let toastTimer;
  let renderVersion = 0;
  const validHandle = value => typeof value === 'string' && /^[a-z0-9][a-z0-9-]*$/i.test(value);
  const safeItem = raw => {
    if (!raw || !validHandle(raw.handle)) return null;
    const url = typeof raw.url === 'string' && raw.url.startsWith('/') && !raw.url.startsWith('//') && raw.url.includes('/products/')
      ? raw.url : root + 'products/' + raw.handle;
    const image = typeof raw.image === 'string' && /^(https:\/\/|\/\/|\/(?!\/))/.test(raw.image) ? raw.image : '';
    const variantId = /^\d+$/.test(String(raw.variantId || '')) ? String(raw.variantId) : '';
    return {handle: raw.handle, url, image, variantId, title: String(raw.title || raw.handle).slice(0, 200)};
  };
  const read = () => {
    try {
      const data = JSON.parse(localStorage.getItem(KEY) || '[]');
      return Array.isArray(data) ? data.slice(0, MAX).map(safeItem).filter(Boolean) : [];
    } catch { return []; }
  };
  saved = read();
  const write = () => { try { localStorage.setItem(KEY, JSON.stringify(saved)); } catch {} };
  const element = (tag, cls, text) => {
    const el = document.createElement(tag);
    if (cls) el.className = cls;
    if (text !== undefined) el.textContent = text;
    return el;
  };
  const notify = message => {
    document.querySelector('.cm-wishlist-toast')?.remove();
    const el = element('div', 'cm-wishlist-toast');
    el.setAttribute('role', 'status');
    const label = element('span', '', message);
    const link = element('a', '', 'View wishlist');
    link.href = pageUrl;
    el.append(label, link);
    document.body.append(el);
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => el.remove(), 3700);
  };
  const currency = () => document.querySelector('[data-cm-currency]')?.getAttribute('data-cm-currency') ||
    window.Shopify?.currency?.active || 'USD';
  const money = cents => {
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en', {
        style: 'currency', currency: currency(), currencyDisplay: 'symbol'
      }).format(Number(cents) / 100);
    } catch { return ''; }
  };
  const fetchProduct = handle => {
    if (!products.has(handle)) {
      const request = fetch(root + 'products/' + encodeURIComponent(handle) + '.js', {
        credentials: 'same-origin', headers: {Accept: 'application/json'}
      }).then(async response => {
        if (!response.ok) throw new Error('Product unavailable');
        const product = await response.json();
        if (!product || !Array.isArray(product.variants) || !product.variants.length) throw new Error('Missing variants');
        return product;
      }).catch(error => { products.delete(handle); throw error; });
      products.set(handle, request);
    }
    return products.get(handle);
  };
  const syncButtons = () => {
    const handles = new Set(saved.map(item => item.handle));
    document.querySelectorAll('[data-cm-wishlist-toggle]').forEach(button => {
      const active = handles.has(button.dataset.cmHandle);
      button.classList.toggle('is-saved', active);
      button.setAttribute('aria-pressed', String(active));
      button.setAttribute('aria-label', (active ? 'Remove ' : 'Save ') +
        (button.dataset.cmTitle || 'piece') + (active ? ' from wishlist' : ' to wishlist'));
      button.title = active ? 'Remove from wishlist' : 'Save to wishlist';
      const label = button.querySelector('.cm-wishlist-toggle__label');
      if (label) label.textContent = active ? 'Saved to wishlist' : 'Save to wishlist';
    });
    document.querySelectorAll('[data-cm-wishlist-count]').forEach(badge => {
      badge.textContent = String(saved.length);
      badge.hidden = saved.length === 0;
    });
  };
  const renderPage = () => {
    const grid = document.querySelector('[data-cm-wishlist-grid]');
    if (!grid) return;
    const version = ++renderVersion;
    const empty = document.querySelector('[data-cm-wishlist-empty]');
    const count = document.querySelector('[data-cm-wishlist-page-count]');
    grid.replaceChildren();
    grid.hidden = saved.length === 0;
    if (empty) empty.hidden = saved.length > 0;
    if (count) count.textContent = saved.length + (saved.length === 1 ? ' saved piece' : ' saved pieces');
    const fragment = document.createDocumentFragment();
    saved.forEach(item => {
      const card = element('article', 'cm-wishlist-item');
      card.dataset.cmHandle = item.handle;
      const picture = element('a', 'cm-wishlist-item__media');
      picture.href = item.url;
      if (item.image) {
        const img = element('img');
        img.src = item.image; img.alt = item.title; img.loading = 'lazy';
        img.width = 480; img.height = 600; picture.append(img);
      }
      const remove = element('button', 'cm-wishlist-item__remove', '×');
      remove.type = 'button';
      remove.dataset.cmWishlistRemove = item.handle;
      remove.setAttribute('aria-label', 'Remove ' + item.title + ' from wishlist');
      const title = element('h2', 'cm-wishlist-item__name');
      const titleLink = element('a', '', item.title);
      titleLink.href = item.url; title.append(titleLink);
      const price = element('p', 'cm-wishlist-item__price', 'Checking price…');
      const choice = element('div', 'cm-wishlist-item__variant');
      choice.hidden = true;
      const choiceLabel = element('label', 'cm-wishlist-item__variant-label', 'Size');
      const select = element('select', 'cm-wishlist-item__select');
      select.setAttribute('aria-label', 'Choose size for ' + item.title);
      const choiceId = 'cm-wishlist-variant-' + item.handle;
      select.id = choiceId; choiceLabel.htmlFor = choiceId;
      select.dataset.cmWishlistVariant = item.handle;
      choice.append(choiceLabel, select);
      const actions = element('div', 'cm-wishlist-item__actions');
      const add = element('button', 'cm-wishlist-item__action', 'Add to cart');
      add.type = 'button';
      add.dataset.cmWishlistPurchase = 'cart';
      add.disabled = true;
      const status = element('p', 'cm-wishlist-item__status');
      status.setAttribute('role', 'status');
      actions.append(add);
      card.append(picture, remove, title, price, choice, actions, status);
      fragment.append(card);
      fetchProduct(item.handle).then(product => {
        if (version !== renderVersion || !card.isConnected) return;
        const variants = product.variants;
        // Shopify's product JSON includes the actual option names and each variant's option values.
        // Keep the saved finish/color fixed: the wishlist picker must only change ring size.
        const optionNames = (product.options || []).map(option =>
          typeof option === 'string' ? option : String(option?.name || '')
        );
        const sizeIndex = optionNames.findIndex(name => /size|размер|größe|taille|talla/i.test(name));
        const variantOptions = variant =>
          Array.isArray(variant.options) ? variant.options :
          [variant.option1,variant.option2,variant.option3].slice(0,optionNames.length);
        const chosen = variants.find(variant => String(variant.id) === item.variantId) ||
          variants.find(variant => variant.available) || variants[0];
        const chosenOptions = variantOptions(chosen);
        const sameFinish = variant => {
          const options = variantOptions(variant);
          return optionNames.every((name,index) =>
            index === sizeIndex || String(options[index] ?? '') === String(chosenOptions[index] ?? '')
          );
        };
        const matched = sizeIndex >= 0 ? variants.filter(sameFinish) : [chosen];
        const candidates = matched.length ? matched : [chosen];
        const selected = candidates.find(variant =>
          String(variant.id) === item.variantId && variant.available
        ) || candidates.find(variant => variant.available) || candidates[0];
        const updateVariant = variant => {
          card.dataset.cmSelectedVariantId = String(variant.id);
          price.textContent = money(variant.price);
          // Match the product picture to the saved finish when Shopify supplies a variant image.
          const variantImage = variant.featured_image?.src;
          if (variantImage && /^https?:\/\//.test(variantImage)) {
            const img = picture.querySelector('img');
            if (img) img.src = variantImage;
          }
          if (variant.available) {
            add.disabled = false;
            status.textContent = '';
          } else {
            add.disabled = true;
            status.textContent = 'Currently unavailable';
          }
        };
        if (sizeIndex >= 0 && candidates.length > 1) {
          choice.hidden = false;
          candidates.forEach(variant => {
            const rawSize = String(variantOptions(variant)[sizeIndex] ?? '').trim();
            const shortSize = rawSize.replace(/^size\s*[:#-]?\s*/i,'').trim() || rawSize;
            const option = element('option', '', shortSize + (variant.available ? '' : ' — Sold out'));
            option.value = String(variant.id);
            option.disabled = !variant.available;
            select.append(option);
          });
          select.value = String(selected.id);
          select.addEventListener('change', () => {
            const variant = candidates.find(entry => String(entry.id) === select.value);
            if (!variant) return;
            const target = saved.find(entry => entry.handle === item.handle);
            if (target) { target.variantId = String(variant.id); write(); }
            updateVariant(variant);
          });
        }
        updateVariant(selected);
      }).catch(() => {
        if (version !== renderVersion || !card.isConnected) return;
        price.textContent = 'See product for current price';
        status.textContent = 'Please open the product to choose an available option.';
      });
    });
    grid.append(fragment);
  };
  const refresh = () => { syncButtons(); renderPage(); };
  const purchase = async button => {
    const card = button.closest('.cm-wishlist-item');
    const variantId = card?.dataset.cmSelectedVariantId;
    if (!/^\d+$/.test(variantId || '')) return;
    const buttons = card.querySelectorAll('[data-cm-wishlist-purchase]');
    buttons.forEach(el => el.disabled = true);
    const original = button.textContent;
    button.textContent = 'Adding…';
    const status = card.querySelector('.cm-wishlist-item__status');
    try {
      const response = await fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: {'Content-Type':'application/json','Accept':'application/json'},
        credentials:'same-origin',
        body: JSON.stringify({items:[{id:Number(variantId),quantity:1}]})
      });
      const data = await response.json();
      if (!response.ok) throw new Error(data.description || data.message || 'Unable to add item');
      window.location.assign(root + 'cart');
    } catch (error) {
      status.textContent = error.message || 'Something went wrong. Please try again.';
      button.textContent = original;
      buttons.forEach(el => el.disabled = false);
    }
  };
  document.addEventListener('click', event => {
    const target = event.target;
    if (!(target instanceof Element)) return;
    const toggle = target.closest('[data-cm-wishlist-toggle]');
    if (toggle) {
      event.preventDefault(); event.stopImmediatePropagation();
      const form = toggle.closest('product-component')?.querySelector('product-form-component input[name="id"]');
      const item = safeItem({
        handle:toggle.dataset.cmHandle,url:toggle.dataset.cmUrl,title:toggle.dataset.cmTitle,
        image:toggle.dataset.cmImage,variantId:form?.value || toggle.dataset.cmVariantId
      });
      if (!item) return;
      const index = saved.findIndex(entry => entry.handle === item.handle);
      if (index >= 0) saved.splice(index,1);
      else saved.unshift(item);
      saved = saved.slice(0,MAX);
      write();refresh();
      notify(index >= 0 ? 'Removed from your wishlist' : 'Added to your wishlist');
      return;
    }
    const remove = target.closest('[data-cm-wishlist-remove]');
    if (remove) {
      event.preventDefault();
      saved = saved.filter(item => item.handle !== remove.dataset.cmWishlistRemove);
      write();refresh();
      return;
    }
    const action = target.closest('[data-cm-wishlist-purchase]');
    if (action && !action.disabled) {
      event.preventDefault();
      purchase(action);
    }
  }, true);
  window.addEventListener('storage', event => {
    if (event.key === KEY) { saved = read(); refresh(); }
  });
  document.addEventListener('shopify:section:load', refresh);
  let scheduled = false;
  const observer = new MutationObserver(records => {
    if (records.some(rec => [...rec.addedNodes].some(node => node.nodeType === 1 &&
      (node.matches?.('[data-cm-wishlist-toggle]') || node.querySelector?.('[data-cm-wishlist-toggle]'))))) {
      if (!scheduled) {
        scheduled = true;
        requestAnimationFrame(() => {scheduled = false;syncButtons();});
      }
    }
  });
  const init = () => {refresh();observer.observe(document.body,{subtree:true,childList:true});};
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',init,{once:true});
  else init();
})();
